import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Typography } from '@telus-uds/components-web';

import ErrorIcon from '../../../../../assets/images/icon_error_messages.gif';
import { FormBox } from '../../../css';

const InputField = ({
  label,
  type='text',
  errors={},
  touched={},
  name,
  placeholder='',
  readOnly = false,
  setFieldValue,
  note
}) => {
  return (
    <FormBox>
      <div className="main-content-form-headers">
        <Typography block heading="h4" variant={{ size: 'h4' }}>{label}</Typography>
      </div>
      {note && (
        <div style={{ marginBottom: '10px', fontSize: '12px', color: '#666' }}>
          {note}
        </div>
      )}
      <div
        style={{ position: 'relative' }}
        className={`input-container ${errors[name] && touched[name] ? 'error' : ''
          }`}
      >
        <Field
          name={name}
          type={type}
          className="select-style"
          placeholder={placeholder}
          readOnly={readOnly}
          onChange={e => {
            setFieldValue(e.target.value);
          }}
        />

        <>
          <div className="error_messages">
            <Typography variant={{ colour: 'error' }}>{errors[name]}</Typography>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </FormBox>
  );
};

InputField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  errors: PropTypes.objectOf(PropTypes.string),
  touched: PropTypes.objectOf(PropTypes.bool),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  note: PropTypes.string
};

export default InputField;
